import React from 'react';
import loaderIcon from '../../../assets/images/icons/loader.gif';
import { useOnboardingStep } from '../../../context/OnboardingStepContext';
import OnboardingStep1 from './OnboardingStep1';
import OnboardingStep2 from './OnboardingStep2';
import OnboardingStep3 from './OnboardingStep3';

const OnboardingMain = (props) => {
    const { currentStep, handleNext, registerStep, setRegisterStep } = useOnboardingStep();

    const isRegisterFlow = props.callFrom === "register";
    const step = isRegisterFlow ? registerStep : currentStep;
    const onNext = isRegisterFlow ? () => setRegisterStep(s => s + 1) : handleNext;

    return (
        <div>

            {!isRegisterFlow && step === null && (
                <div className="loader_container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                    <img src={loaderIcon} alt="Loading" className="loader_icon" />
                </div>
            )}
            {step === 0 && (
                <OnboardingStep1
                    {...props}
                    onNext={onNext}
                />
            )}
            {step === 1 && (
                <OnboardingStep2
                    {...props}
                    onNext={onNext}
                />
            )}
            {step === 2 && (
                <OnboardingStep3
                    {...props}
                />
            )}
        </div>
    );
};

export default OnboardingMain;
